import { Row } from '@workramp/ui';
import styled from 'styled-components';

export const FooterWrapper = styled.div`
  box-sizing: border-box;
  height: ${({ theme }) => theme.spacing(12)}px;
  padding-top: ${({ theme }) => theme.spacing(2)}px;
  padding-bottom: ${({ theme }) => theme.spacing(2)}px;

  & p,
  & a,
  & span {
    font-weight: 500;
  }
`;

export const FullHeightRow = styled(Row)`
  height: 100%;
`;

// anchor tag used to wrap components and make the window.status bar show the href
export const WindowStatusAnchor = styled.a`
  color: ${({ theme }) => theme.colors.on[900]};
  text-decoration: none;

  &:link,
  &:hover,
  &:visited,
  &:active {
    color: inherit;
    text-decoration: none;
  }
`;
